export default "__VITE_ASSET__B5p5gb4g__"